import React from 'react';
import useStyle from './carouselNav.style';
import { SubTitle } from 'components/atoms/Texts/SubTitle';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { AvatarPagination } from 'components/atoms/Texts/AvatarPagination';

export interface CarouselNavProps {
  text: string;
  previous: () => void;
  next: () => void;
  isMobile?: boolean;
  hideArrows?: boolean;
  variant?:
    | 'default'
    | 'classic'
    | 'bronze'
    | 'silver'
    | 'gold'
    | 'halloween'
    | 'danger';
}

export const CarouselNav = ({
  text,
  previous,
  next,
  isMobile = false,
  hideArrows = false,
  variant = 'default'
}: CarouselNavProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {!hideArrows && (
        <IconButton variant="backless" icon="LeftArrow" onClick={previous} />
      )}
      {variant === 'default' || variant === 'danger' ? (
        <SubTitle
          isBackground={true}
          isDanger={variant === 'danger'}
          isBlack={isMobile}
          text={text}
        />
      ) : (
        <AvatarPagination text={text} variant={variant} />
      )}
      {!hideArrows && (
        <IconButton variant="backless" icon="RightArrow" onClick={next} />
      )}
    </div>
  );
};
